<template>
  <a-card :bordered="false" class="card-area">
    <div>
      <!-- 搜索区域 -->
      <a-form layout="horizontal">
        <a-row>
          <a-col :md="24" :sm="24" style="display: flex">
            <a-form-item
              style="width: 500px"
              label="收集员名称"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 15, offset: 1 }">
              <a-input
                placeholder="收集员真实名称"
                v-model="queryParams.checkerPhone"
              />
            </a-form-item>


            <a-form-item
              label="收集日期"
              :labelCol="{ span: 4 }"
              :wrapperCol="{ span: 18, offset: 1 }"
            >
              <div style="display: flex">
                <a-date-picker :default-value="moment()" @change="onSDateChange"/>
                <span style="padding: 0px 10px 0px 10px">至</span>
                <a-date-picker :default-value="moment()" @change="onEDateChange"/>
              </div>
            </a-form-item>
            <a-form-item
              style="width: 400px"
              label="垃圾类型"
              :labelCol="{ span: 4 }"
              :wrapperCol="{ span: 18, offset: 1 }"
            >
              <a-select v-model="queryParams.bukIndex" placeholder="请选择">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">易腐垃圾</a-select-option>
                <a-select-option value="2">其他垃圾</a-select-option>
                <a-select-option value="3">可回收垃圾</a-select-option>
                <a-select-option value="4">有害垃圾</a-select-option>
              </a-select>
            </a-form-item>
<!--            <label style="width: 90px;" class="search-label">收集异常：</label>-->
<!--            <a-select style="width: 150px" placeholder="是否异常" v-model="queryParams.exceptionType">-->
<!--              <a-select-option value="">全部</a-select-option>-->
<!--              <a-select-option value="no">否</a-select-option>-->
<!--              <a-select-option value="yes">是</a-select-option>-->
<!--            </a-select>-->
          </a-col>
        </a-row>
        <a-row class="d-flex">
          <a-col style="display:flex" :md="24" :sm="24">
            <label style="width: auto" class="search-label">请选择区域：</label>
            <AreaCascader style="width: 300px" @loaded="onLoaded" ref="select"/>

            <label style="width: 70px;margin-left: 40px" class="search-label">分类情况：</label>
            <a-select style="width: 150px" placeholder="选择分类情况" v-model="queryParams.result">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">不合格</a-select-option>
              <a-select-option value="1">合格</a-select-option>
              <a-select-option value="2">空桶</a-select-option>
            </a-select>
            <a-input style="width:200px;margin-left: 20px;margin-right: 20px" v-model="queryParams.phone"
                     placeholder="用户或手机号"></a-input>
            <a-select style="width: 150px" placeholder="选择用户身份" v-model="queryParams.identity">
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="1">群众</a-select-option>
              <a-select-option :value="2">党员</a-select-option>
              <a-select-option :value="3">村民代表</a-select-option>
              <a-select-option :value="4">租户</a-select-option>
              <a-select-option :value="5">房东</a-select-option>
            </a-select>
            <a-button style="margin-left: 20px" type="primary" @click="search">查询</a-button>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <div class="export">
      <a-button @click="handleExportClick" type="primary">导出表格
        <a-icon type="down"/>
      </a-button>
      <div class="hint-box">
        <a-checkbox @change="onChange">
          是否导出图片
        </a-checkbox>
        <span class="hint" v-if="withImg">
          请适当导出带图片的垃圾分类数据，导出数据量越大，等待的时间越长。<br/>
          导出过程中，请勿重复点击导出按钮。
        </span>
      </div>

      <a-button v-if="selectedRowKeys.length > 0 " @click="showBatchEdit" type="primary">批量修改
      </a-button>
    </div>



    <div class="details-box">
      <p v-show="showDetails">总天数：<span v-text="totalDays"></span></p>
      <p v-show="showDetails">参与次数：<span v-text="actorNum"></span></p>
      <p v-show="showDetails">合格次数：<span v-text="qualified"></span></p>
      <p v-show="showDetails">不合格次数：<span v-text="noQualified"></span></p>
      <p v-show="showDetails">空桶：<span v-text="empty"></span></p>
      <p v-show="showDetails">总重量<span v-text="totalWeight"></span>千克</p>
      <p v-show="showTotalWeight">总计：<span v-text="memberCount"></span></p>
    </div>
    <div>
      <!-- 表格区域 -->
      <a-table
        ref="TableInfo"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        :loading="loading"
        :scroll="{ x: 900 }"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange"
        :customRow="customRow"
      >
        <template slot="email" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <div>{{ text }}</div>
            </template>
            <p style="width: 150px;margin-bottom: 0">{{ text }}</p>
          </a-popover>
        </template>
        <template slot="imgs" slot-scope="text, record">
          <img onerror="javascript:this.src='/static/img/overdueImg.png';" :src = 'record.imgs[0]' width = '80px' height = '80px' @click="showImg(record.imgs[0])"/>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-button type="text" @click="photos(record)">详细</a-button>
        </template>
      </a-table>
    </div>

    <div v-if="modalVisible" id="details_modal"
         style="width: 100%; height: 100%; position: fixed; background: rgba(0, 0, 0, 0.26); left: 0px; top: 0px; z-index: 2;">
      <div
        style="height: 545px;left: calc( 50% - 200px );position: absolute;width: 400px;top: 13%;z-index: 99999;background: #fff;border-radius: 5px;">
        <div style="display: flex;color: #000;padding: 10px 22px 20px 30px;">
          <p style="font-size: 16px">{{modalData.bukIndex | handlerBukIndex}}详细信息</p>
          <p style="flex: 1"></p>
          <p @click="onModalClose()" style="font-size: 19px;cursor: pointer;">
            <svg viewBox="64 64 896 896" data-icon="close" width="1em" height="1em" fill="currentColor"
                 aria-hidden="true" class="">
              <path
                d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
            </svg>
          </p>
        </div>
        <div class="ant-modal-body" style="color: rgb(51, 51, 51);padding: 0 30px 30px 30px;
    line-height: 42px;"><p>采集姓名:<span id="cjxm" style="margin-left: 20px; color: rgb(102, 102, 102);">{{modalData.member.name }}</span>
        </p>
          <p style="">采集地址:<span id="cjdz" style="margin-left: 20px; color: rgb(102, 102, 102);">{{modalData.member.areaStr + modalData.member.doorNo}}</span>
          </p>
          <p>分类情况:<span id="flqk" style="margin-left: 20px; color: rgb(102, 102, 102);">{{modalData.result==0?'不合格':(modalData.result==1?'合格':'空桶')}}</span>
          </p>
          <p>环保积分:<span id="hbjf" style="margin-left: 20px; color: rgb(102, 102, 102);">{{modalData.score}}</span>
          </p>
          <p>
            重量:
            <span id="yfzl" style="margin-left: 20px;">
              {{ (isAdminUser && modalData.status === 8) ? modalData.totalWeight : modalData.weight }}kg
            </span>
          </p>
          <p>收集人员:<span id="sjry"
                        style="margin-left: 20px; color: rgb(102, 102, 102);">{{modalData.checker.name}}</span>
          </p>
          <p>收集时间<span id="tdrq" style="margin-left: 20px; color: rgb(102, 102, 102);">{{modalData.createTime}}</span>
          </p>
          <p>实时图片:<img id="sstp" @click="showImg(modalData.imgs[0])" onerror="javascript:this.src='/static/img/overdueImg.png';"
                       style="width: 120px; height: 120px; margin-left: 20px;cursor: pointer" :src="modalData.imgs[0]">
          </p>
          <p>
            是否合格:
            <select v-model="currentSelect" id="record_result" style="margin-left: 20px; color: rgb(102, 102, 102);">
              <option value="1">合格</option>
              <option value="0">不合格</option>
              <option value="2">空桶</option>
            </select>
          </p>
          <p>
            是否脏桶:
            <select v-model="currentClean" id="clean_result" style="margin-left: 20px; color: rgb(102, 102, 102);">
              <option value="1">否</option>
              <option value="0">是</option>
            </select>
          </p>
          <div style="width: 100%;display: flex;justify-content: center;">
            <button type="button" style="line-height: 19px;" @click="xghg()">审核</button>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      title="大图展示"
      v-model="imgvisiable"
      :closable="true"
      :width="640"
      :footer="false">
      <img width="600" :src="imgPath" onerror="javascript:this.src='/static/img/overdueImg.png';"/>
    </a-modal>

    <a-modal v-model="pictureVisible" title="修改图片" :maskClosable="false" width="60%" @ok="handlePictureOk" @cancel="handlePictureCancel">
      <div>
        <a-row>
          <a-col :span="8">
            <AreaCascader style="width: 350px" @loaded="onLoadedPicture" ref="selectPicture"/>
          </a-col>
          <a-col :span="8">
            <span>日期：</span>
            <a-range-picker @change="onChangePicture" style="width: 300px;" :format="dateFormat" v-model="replacePicture.rangePicker"/>
          </a-col>
          <a-col :span="8">
            <span>垃圾类型：</span>
            <a-select placeholder="请选择垃圾类型" style="width: 150px;" v-model="replacePicture.bukIndex">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">易腐垃圾</a-select-option>
              <a-select-option value="2">其他垃圾</a-select-option>
              <a-select-option value="3">可回收垃圾</a-select-option>
              <a-select-option value="4">有害垃圾</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <span>分类情况：</span>
            <a-select placeholder="请选择分类情况" style="width: 150px;" v-model="replacePicture.result">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">不合格</a-select-option>
              <a-select-option value="1">合格</a-select-option>
              <a-select-option value="2">空桶</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="8" style="display: flex; justify-content: start;align-items: center;">
            <span>重量：</span>
            <a-input placeholder="请输入重量" style="width: 150px;" v-model="replacePicture.weight"/>
          </a-col>
          <a-col :span="8" style="display: flex; justify-content: center; align-items: center;">
            <a-button type="primary" @click="searchPicture">搜索</a-button>
          </a-col>
        </a-row>

        <div style="margin-top: 50px;min-height: 100px;max-height: 500px;overflow-y: auto;" ref="replacePicture">
          <div style="display: flex; justify-content: center;align-items: center;min-height: 100px;" v-if="spinning">
            <a-spin tip="数据加载中..." :spinning="spinning"/>
          </div>
          <a-checkbox-group @change="onChangeReplacePicture" style="display: grid; grid-template-columns: repeat(5, 20%);" v-model="checkedValue">
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;margin-bottom: 30px;" v-for="item in replaceCheckRecord" :key="item.id">
              <img :src="item.imgs[0]" style="width: 160px; height: 160px;margin-bottom: 10px;">
              <a-checkbox :value="item.imgs[0]">
                勾选
              </a-checkbox>
            </div>
          </a-checkbox-group>
        </div>
      </div>
    </a-modal>

    <a-modal title="批量修改" :maskClosable="false" width="500px" @ok="handleBatchEdit" @cancel="hideBatchEditVisible" v-model="batchEditVisible" >
      <a-select style="width: 150px" placeholder="选择分类情况" v-model="currentSelect">
        <a-select-option :value="1">合格</a-select-option>
        <a-select-option :value="0">不合格</a-select-option>
        <a-select-option :value="2">空桶</a-select-option>
      </a-select>
      <p style="margin-top: 20px" v-if="currentEditIndex>=0">正在修改第：{{currentEditIndex+1}}条数据</p>
    </a-modal>
  </a-card>
</template>

<script>
  import DeptInputTree from '../system/dept/DeptInputTree'
  import RangeDate from '@/components/datetime/RangeDate'
  import ACol from 'ant-design-vue/es/grid/Col'
  import area from '../../utils/area'
  import AreaCascader from '@/components/select/AreaCascader'
  import moment from 'moment'

  moment.locale('zh-cn')

  const formItemLayout = {
    labelCol: {span: 4},
    wrapperCol: {span: 17}
  }
  export default {
    name: 'Record',
    components: {ACol, DeptInputTree, RangeDate, AreaCascader},
    data() {
      return {
        isAdminUser: false,
        spinning: false,
        form: this.$form.createForm(this),
        modalTitle: '',
        batchEditVisible:false,
        modalVisible: false,
        currentSelect: 1,
        currentClean: 1,
        modalData: {},
        memberCount: 0,
        totalDays: 0,
        actorNum: 0,
        qualified: 0,
        noQualified: 0,
        empty: 0,
        totalWeight: 0,
        formItemLayout,
        imgvisiable: false,
        imgPath: '',
        options: area,
        queryParams: {},
        filteredInfo: null,
        sortedInfo: null,
        timeType: {
          value: 1,
          options: [
            {
              label: '天数',
              value: 1,
            },
            {
              label: '月份',
              value: 2,
            },
            {
              label: '年份',
              value: 3,
            },
          ],
        },
        searchKeyValue: '',
        paginationInfo: null,
        validateStatus: '',
        dataSource: [],
        selectedRowKeys: [],
        currentEditIndex:0,
        searchKeyPhone: '',
        loading: false,
        pagination: {
          pageSizeOptions: ['10', '20', '30', '40', '100'],
          defaultCurrent: 1,
          defaultPageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total, range) =>
            `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
        },
        cityData: {
          defaultValue: '',
          options: [],
          defaultValue2: '',
          options2: [],
          defaultValue3: '',
          options3: [],
          defaultValue4: '',
          options4: []
        },
        showDetails: false,
        showTotalWeight: false,
        withImg: false,
        pictureVisible: false,
        dateFormat: 'YYYY-MM-DD',
        replacePicture: {
          streetId: 0,
          rangePicker: [moment(), moment()],
          sdate: '',
          edate: '',
          bukIndex: '',
          result: '',
          weight: 0.0,
          checkRecordId: 0
        },
        checkedValue: [],
        replaceCheckRecord: []
      }
    },
    created() {
      // 判断是否是特殊账号
      const user = JSON.parse(localStorage.getItem('USER') || '{}');
      this.isAdminUser = user.username === '123456';
    },
    computed: {
      columns() {
        let {sortedInfo, filteredInfo} = this
        sortedInfo =
          sortedInfo ||
          {
            //{}
          };
        const user = JSON.parse(localStorage.getItem('USER') || '{}');
        const isAdminUser = user.username === '123456';

        return [
          {
            title: '姓名',
            dataIndex: 'member.name'
          },
          {
            title: '手机号',
            dataIndex: 'member.phone'
          }, {
            title: '身份情况',
            dataIndex: 'member.identity',
            customRender: (text, row, index) => {
              switch (row.member.identity) {
                case 1:
                  return <img title='群众' width='45px' src='/static/img/qz.png' />
                case 2:
                  return <img title='党员' width='45px' src='/static/img/dy.png' />
                case 3:
                  return <img title='村民代表' width='45px' src='/static/img/fr.png' />
                case 4:
                  return <img title='租户' width='45px' src='/static/img/zh.png' />
                case 5:
                  return <img title='房东' width='45px' src='/static/img/fd.png' />
                case 6:
                  return <img title='商家' width='45px' src='/static/img/sj.png' />
                case 7:
                  return <img title='村两委干部' width='45px' src='/static/img/ganbu.png' />
              }
              return '-'
            }
          },
          {
            title: '地址',
            dataIndex: 'member.doorNo',
            customRender: (text, row, index) => {
              return row.member.areaStr + row.member.doorNo
            }
          },
          {
            title: '分类情况',
            dataIndex: 'result',
            customRender: (text, row, index) => {
              switch (row.result) {
                case 0:
                case '0':
                  return <span style="color: red;">不合格</span>
                case 1:
                case '1':
                  return '合格'
                case 2:
                case '2':
                  return '空桶'
              }
              return '--'
            }
          },
          /*{
            title: 'AI识别',
            dataIndex: 'result',
            customRender: (text, row, index) => {
              switch (row.aiResult) {
                case 0:
                case '0':
                  return <span style="color: red;">不合格</span>
                case 1:
                case '1':
                  return '合格'
                case 2:
                case '2':
                  return '空桶'
                case -1:
                case '-1':
                  return '未识别'
              }
              return '未使用'
            }
          },*/
          {
            title: '环保积分',
            dataIndex: 'score'
          },
          {
            title: '垃圾重量',
            dataIndex: 'weight',
            // 关键：自定义渲染
            customRender: (text, record, index) => {
              if (isAdminUser && record.status === 8) {
                // 渲染异常图片，可设置宽高
                return h('img', {
                  attrs: {
                    src: 'static/img/anomaly8.png'
                  },
                  style: {
                    width: '80px',
                    height: '80px',
                    marginLeft: '-16px'
                  }
                })
              }
              return text || '0';
            }
          },
          {
            title: '垃圾类型',
            customRender: (text, row, index) => {
              return  <img  src = {'/static/img/lj_icon'+row.bukIndex+'.png'} width = '80px' />
            }
          },
          {
            title: '收集员',
            dataIndex: 'checker.name'
          },
          /*{
            title: '实时图片',
            customRender: (text, row, index) => {
              return  <img click = 'alert(1)' onerror="javascript:this.src='/static/img/overdueImg.png';" src = {row.imgs[0]} width = '80px' height = '80px' / >
            }
          },*/
          {
            title: '实时图片',
            dataIndex: 'imgs',
            scopedSlots: {customRender: 'imgs'}
          },
          {
            title: '收集日期',
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: {customRender: 'operation'}
          }
        ]
      }
    },
    mounted() {

    },
    filters: {
      handlerBukIndex: function (value) {
        if (!value) return '';
        value = value.toString();
        let str = '';
        if(value === '1'){
          str = '易腐垃圾';
        }else if(value === '2'){
          str = '其他垃圾';
        }else if(value === '3'){
          str = '可回收垃圾';
        }else if(value === '4'){
          str = '有害垃圾';
        }
        return str;
      }
    },
    methods: {
      hideBatchEditVisible(){
        this.batchEditVisible  = false
      },
      handleBatchEdit(){
        this.doEdit(0)
      },
      doEdit(idx){
        if(this.selectedRowKeys.length <= idx){
          this.$message.success('修改成功')
          this.fetch({
            ...this.queryParams,
          })
          this.hideBatchEditVisible()
          this.selectedRowKeys = []
          return
        }
        this.currentEditIndex = idx
        let v = this.selectedRowKeys[idx]
        let item = this.dataSource[v];

        this.$post('api/change_result_clean', {
          id: item.id, result: this.currentSelect
        })
          .then(() => {
           this.doEdit(idx+1)
          }).catch(()=>{
          this.doEdit(idx+1)
        })
      },
      showBatchEdit(){
        this.currentEditIndex = -1
        this.currentSelect = 1
        this.batchEditVisible  = true
      },
      handleExportClick(e) {
        console.log('click', e);
        this.exportExcel(e.key)
      },
      exportExcel() {
        let {sortedInfo, filteredInfo} = this
        let sortField, sortOrder
        // 获取当前列的排序和列的过滤规则
        if (sortedInfo) {
          sortField = sortedInfo.field
          sortOrder = sortedInfo.order
        }
        this.queryParams.streetId = this.$refs.select.getValue()
        this.queryParams['withImg'] = this.withImg
        this.$export('checkRecord/excel', {
          sortField: sortField,
          sortOrder: sortOrder,
          ...this.queryParams,
          ...filteredInfo
        })
      },
      moment,
      showImg(img) {
        this.imgPath = img
        this.imgvisiable = true
      },
      close() {
        this.imgvisiable = false
      },
      xghg() {
        this.$post('api/change_result_clean', {
          id: this.modalData.id, result: this.currentSelect, weight: this.modalData.weight, clean: this.currentClean
        })
          .then(() => {
            this.modalData.result = this.currentSelect
            this.modalData.clean = this.currentClean
            this.onModalClose()
            this.$message.success('修改成功')
            this.fetch({
              ...this.queryParams,
            })
          })
        // let result = $("#record_result").val()
        // postJson(baseUrl + '/api/change_result',{id:currentData.id,result:result},function (res) {
        //   console.info(res)
        //   if(res.data){
        //     currentData.result = result
        //     alert('修改成功')
        //   }
        // })
      },
      onLoaded() {
        let v = moment().format('YYYY-MM-DD')
        this.queryParams.sdate = v
        this.queryParams.edate = v
        this.fetch({
          ...this.queryParams,
        })
      },
      onSDateChange(date, dateString) {
        this.queryParams.sdate = dateString
      },
      onEDateChange(date, dateString) {
        this.queryParams.edate = dateString
      },
      doExport() {
      },
      onCityChange() {
      },
      datePickerChange(value, stringValue) {
        this.dateValue = stringValue
      },
      handleSubmit() {
        this.form.validateFields((err, values) => {
          if (!err && this.validateStatus === 'success') {
            this.loading = true
            this.user.roleId = this.user.roleId.join(',')
            this.$post('user', {
              ...this.user
            })
              .then(r => {
                this.reset()
                this.$emit('success')
              })
              .catch(() => {
                this.loading = false
              })
          }
        })
      },
      onModalClose() {
        this.modalVisible = false
      },
      add(record) {
        this.modalTitle = '新增收集员'
        this.modalVisible = true
        this.modalData = record
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
        if (!this.advanced) {
          this.queryParams.createTimeFrom = ''
          this.queryParams.createTimeTo = ''
        }
      },
      del(record) {
        let that = this
        this.$confirm({
          title: '确定删除吗?',
          content: '当您点击确定按钮后，这些记录将会被彻底删除',
          centered: true,
          onOk() {
            let userIds = []
            for (let key of that.selectedRowKeys) {
              userIds.push(that.dataSource[key].userId)
            }
            // that.$delete('member/' + record.id).then(() => {
            //   that.$message.success('删除成功')
            //   that.selectedRowKeys = []
            //   that.search()
            // })
            setTimeout(function () {
              that.$message.success('删除成功')
              that.dataSource.splice(that.selectedRowKeys[0], 1)
              that.selectedRowKeys = []
            }, 50)
          },
          onCancel() {
            that.selectedRowKeys = []
          }
        })
      },

      photos(record) {
        this.modalTitle = '详细'
        this.modalVisible = true
        this.currentSelect = record.result
        this.currentClean = record.clean === undefined?1:record.clean
        this.modalData = record
      },
      handleUserEditClose() {
        this.userEdit.visiable = false
      },
      handleUserEditSuccess() {
        this.userEdit.visiable = false
        this.$message.success('修改用户成功')
        this.search()
      },
      handleUserInfoClose() {
        this.userInfo.visiable = false
      },
      handleDeptChange(value) {
        this.queryParams.deptId = value || ''
      },
      handleDateChange(value) {
        if (value) {
          this.queryParams.createTimeFrom = value[0]
          this.queryParams.createTimeTo = value[1]
        }
      },
      batchDelete() {
        if (!this.selectedRowKeys.length) {
          this.$message.warning('请选择需要删除的记录')
          return
        }
        let that = this
        this.$confirm({
          title: '确定删除所选中的记录?',
          content: '当您点击确定按钮后，这些记录将会被彻底删除',
          centered: true,
          onOk() {
            let userIds = []
            for (let key of that.selectedRowKeys) {
              userIds.push(that.dataSource[key].userId)
            }
            // that.$delete('user/' + userIds.join(',')).then(() => {
            //   that.$message.success('删除成功')
            //   that.selectedRowKeys = []
            //   that.search()
            // })
            setTimeout(function () {
              that.$message.success('删除成功')
              that.selectedRowKeys = []
              that.dataSource = []
              that.search()
            }, 50)
          },
          onCancel() {
            that.selectedRowKeys = []
          }
        })
      },
      resetPassword() {
        if (!this.selectedRowKeys.length) {
          this.$message.warning('请选择需要重置密码的用户')
          return
        }
        let that = this
        this.$confirm({
          title: '确定重置选中用户密码?',
          content: '当您点击确定按钮后，这些用户的密码将会重置为000000',
          centered: true,
          onOk() {
            let usernames = []
            for (let key of that.selectedRowKeys) {
              usernames.push(that.dataSource[key].username)
            }
            that
              .$put('user/password/reset', {
                usernames: usernames.join(',')
              })
              .then(() => {
                that.$message.success('重置用户密码成功')
                that.selectedRowKeys = []
              })
          },
          onCancel() {
            that.selectedRowKeys = []
          }
        })
      },
      search() {
        let {sortedInfo, filteredInfo} = this
        let sortField, sortOrder
        // 获取当前列的排序和列的过滤规则
        if (sortedInfo) {
          sortField = sortedInfo.field
          sortOrder = sortedInfo.order
        }
        this.paginationInfo = null;
        this.fetch({
          sortField: sortField,
          sortOrder: sortOrder,
          ...this.queryParams,
          ...filteredInfo
        })
      },
      reset() {
        // 取消选中
        this.selectedRowKeys = []
        // 重置分页
        this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
        if (this.paginationInfo) {
          this.paginationInfo.current = this.pagination.defaultCurrent
          this.paginationInfo.pageSize = this.pagination.defaultPageSize
        }
        // 重置列过滤器规则
        this.filteredInfo = null
        // 重置列排序规则
        this.sortedInfo = null
        // 重置查询参数
        this.queryParams = {}
        // 清空部门树选择
        this.$refs.deptTree.reset()
        // 清空时间选择
        if (this.advanced) {
          this.$refs.createTime.reset()
        }
        this.fetch()
      },
      handleTableChange(pagination, filters, sorter) {
        // 将这三个参数赋值给Vue data，用于后续使用
        this.paginationInfo = pagination
        this.filteredInfo = filters
        this.sortedInfo = sorter

        this.fetch({
          sortField: sorter.field,
          sortOrder: sorter.order,
          ...this.queryParams,
          ...filters
        })
      },
      fetch(params = {}) {
        // 显示loading
        params.streetId = this.$refs.select.getValue()
        this.loading = true
        if (this.paginationInfo) {
          // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
          this.$refs.TableInfo.pagination.current = this.paginationInfo.current
          this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
          params.pageSize = this.paginationInfo.pageSize
          params.pageNum = this.paginationInfo.current
        } else {
          // 如果分页信息为空，则设置为默认值
          this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
          this.$refs.TableInfo.pagination.pageSize = this.pagination.defaultPageSize
          params.pageSize = this.pagination.defaultPageSize
          params.pageNum = this.pagination.defaultCurrent
        }
        this.$get('checkRecord/list', {
          ...params
        }).then(r => {
          let data = r.data
          const pagination = {...this.pagination}
          pagination.total = data.total
          let dataSource = data.rows
          this.pagination = pagination

          if(params.phone == undefined || params.phone == ''){
            this.memberCount = data.total;
            this.showTotalWeight = true;
          }else {

          }
          dataSource.forEach(function (item) {
            if(item.streetId === 821646){ // 长风村
              item.weight = "手持设备不上传重量"
            }
          })
          this.dataSource = dataSource
          // 数据加载完毕，关闭loading
          this.loading = false
        });

        this.$get('checkRecord/member_count', {
          ...params
        }).then(r => {
          let data = r.data.data;
          console.log(data.memberCount);
          if (params.phone == undefined || params.phone == '') {
            this.showDetails = false;
          } else {
            this.totalDays = data.totalDays;
            this.actorNum = data.actorNum;
            this.qualified = data.qualified;
            this.noQualified = data.noQualified;
            this.empty = data.empty;
            this.totalWeight = data.totalWeight;
            this.showDetails = true;
            this.showTotalWeight = false;
          }

          // this.memberCount = data.memberCount;
        });
      },
      onChange(){
        this.withImg = !this.withImg
        console.log("withImg: ",this.withImg)
      },
      onLoadedPicture(){


      },
      customRow(record, index){
        const that = this
        return {
          on: {
            dblclick: function (event) {
              that.pictureVisible = true

              console.log("record: ", record)
              that.$nextTick(function (){
                that.$refs.selectPicture.setValue(record.streetId);
                that.replacePicture.rangePicker = [moment(record.date), moment(record.date)]
                that.replacePicture.sdate = moment().format("YYYY-MM-DD")
                that.replacePicture.edate = moment().format("YYYY-MM-DD")
                that.replacePicture.bukIndex = record.bukIndex.toString()
                that.replacePicture.result = record.result.toString()
                that.replacePicture.weight = record.weight
                that.replacePicture.checkRecordId = record.id
              })
            }
          }
        }
      },
      handlePictureOk(e){
        let params = {}
        params.checkRecordId = this.replacePicture.checkRecordId
        params.imgs = JSON.stringify(this.checkedValue)
        this.$post("checkRecord/replace/img", params).then(res => {
          console.log("replaceImg: ", res)
          if(res.data.code === 200){
            this.$message.info('图片修改成功');
            this.replaceCheckRecord = []
            this.checkedValue = []
          }
        })

        this.pictureVisible = false
        console.log("handlePictureOk: ", e)
        this.fetch({
          ...this.queryParams,
        })
      },
      handlePictureCancel(){
        this.replaceCheckRecord = [];
      },
      onChangePicture(dates, dateStrings){
        console.log("onChangePicture: ", dateStrings)
        this.replacePicture.sdate = dateStrings[0]
        this.replacePicture.edate = dateStrings[1]
      },
      searchPicture(){
        this.spinning = true
        this.replacePicture.streetId = this.$refs.selectPicture.getValue()
        console.log("searchPicture: ", this.replacePicture)
        let params = {}
        params.pageSize = -1
        params.pageNum = 1

        this.$get("checkRecord/replace/list", {...params ,...this.replacePicture}).then(res => {
          console.log("searchPicture: ", res)
          let data = res.data
          if(data.code === 200){
            this.replaceCheckRecord = data.data
            this.spinning = false
          }
        })
      },
      onChangeReplacePicture(checkedValues){
        this.checkedValue = []
        this.checkedValue.push(checkedValues.at(-1))
      }
    }
  }
</script>
<style lang="less" scoped>
  @import "../../../static/less/Common";

  .xunjian-photo {
    width: 100px;
    height: 100px;
    flex: 1;
    margin-left: 10px;
  }

  #details_modal {
    p {
      margin-bottom: 0px !important;
      line-height: 35px;
    }
  }

  .card-area .details-box {
    display: flex;
    flex-direction: row;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    justify-content: flex-end;
    margin-top: -20px;

    p {
      padding: 0 10px;
    }


  }

  .card-area{
    .export{
      display: flex;
      justify-content: start;
      align-items: center;
      .hint-box{
        margin-left: 20px;
        display: flex;
        justify-content: start;
        align-items: center;
        .hint{
          color: red;
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/xunjian/Record.vue